import React, { useState } from 'react';
import { useRecoilValue } from 'recoil';
import {
  Paper,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Fab,
} from '@mui/material';
import { accountSelectedSelector } from 'atoms';
import { useTranslation } from 'react-i18next';
import ServiceOrdersActions from './ServiceOrdersActions';
import ServiceOrdersRows from './ServiceOrdersRows';
import { Add } from '@mui/icons-material';
import ServiceOrderFormModal from './ServiceOrderFormModal';
import useServiceOrdersData from './useServiceOrdersData';

function ServiceOrdersPage() {
  const accountSelected = useRecoilValue(accountSelectedSelector);
  const [open, setOpen] = useState(false);
  const { t } = useTranslation(['_common', 'service_order']);

  const { data, loading, refetch } = useServiceOrdersData({
    accountSelected,
  });

  return (
    <Box
      sx={{
        pt: 3,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <ServiceOrdersActions />
      <TableContainer
        component={Paper}
        variant="outlined"
        sx={{ flex: '1 1 auto', my: 3, position: 'relative' }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>{t('_common:service_order')}</TableCell>
              {!accountSelected && <TableCell>{t('_common:account')}</TableCell>}
              <TableCell>{t('_common:state')}</TableCell>
              <TableCell>{t('service_order:opening_date')}</TableCell>
              <TableCell>{t('service_order:closing_date')}</TableCell>
              <TableCell>{t('service_order:technic')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <ServiceOrdersRows {...{ data, loading, accountSelected }} />
          </TableBody>
        </Table>
      </TableContainer>

      {accountSelected && (
        <Fab
          color="primary"
          aria-label="add"
          onClick={() => setOpen(true)}
          sx={{ position: 'absolute', bottom: '38px', right: '16px' }}
        >
          <Add />
        </Fab>
      )}

      <ServiceOrderFormModal {...{ open, setOpen, refetch }} />
    </Box>
  );
}

export default ServiceOrdersPage;
